import { CustomerObject } from '../../../params/redux/customer';
import { DeleteOutline } from '@mui/icons-material';
import { fetchClientsCustomerThunk } from '../../../redux/thunks/customer';
import { fetchTeamThunk } from '../../../redux/thunks/team';
import { FormAssigneeObject } from '../../../params/redux/form';
import ImageClass from '../../../assets';
import { TeamMemberObject } from '../../../params/redux/team';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { assignFormThunk, removeAssigneeFormThunk } from '../../../redux/thunks/form';
import { Avatar, Box, Checkbox, Divider, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const AssigneeComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [selectedUsers] = useState<number[]>([]);
    const { formFields } = useSelector((state: RootState) => state.form);
    const { customers } = useSelector((state: RootState) => state.customer);
    const { teams } = useSelector((state: RootState) => state.team);

    const { currentUser } = useSelector((state: RootState) => state.app);

    const users = id ? customers : teams;

    // **Extract assigned user IDs from formFields.assignees**
    const assignedUserIds = new Set(formFields?.assignees?.map((user: FormAssigneeObject) => user.user_id) || []);
    const assignedUsers = users.filter((customer: CustomerObject | TeamMemberObject) => assignedUserIds.has(customer.id));
    const notAssignedUsers = users.filter((customer: CustomerObject | TeamMemberObject) => !assignedUserIds.has(customer.id));

    // const handleToggleUser = (userId: number) => {
    //     setSelectedUsers((prevSelected) => (prevSelected.includes(userId)
    //         ? prevSelected.filter((id) => id !== userId)
    //         : [...prevSelected, userId]));
    // };

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                if (id) {
                    await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                } else {
                    await dispatch(fetchTeamThunk()).unwrap();
                }
            } catch (e) {
                //
            }
        };
        fetchCustomers();
    }, [dispatch, id]);

    const assignUserFormHandler = async (userId: number) => {
        try {
            await dispatch(assignFormThunk({ assignee_id: userId, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            //
        }
    };

    const removeAssigneeFormHandler = async (userId: number) => {
        try {
            await dispatch(removeAssigneeFormThunk({ assignee_id: userId, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            //
        }
    };

    return (
        <Box display="none">
            <Box display="flex" flexDirection="column" gap={1} pb={2} minHeight="34vh" maxHeight="34vh" overflow="auto">
                <Box><Typography variant="h6">These users can view this form</Typography>
                    <Typography variant="body1" color="textDisabled" gutterBottom>Assigned Users</Typography></Box>
                {assignedUsers.length === 0
                    ? (
                        <Typography variant="body2" color="textSecondary" align="center" mt={2}>
                            No members assigned yet.
                        </Typography>
                    )
                    : (
                        assignedUsers.map((user) => (
                            <Box key={user.id} display="flex" justifyContent="space-between" alignItems="center" py={1}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Avatar src={ImageClass.userPlacedholder} />
                                    <Typography variant="body2">{`${user.first_name} ${user.last_name}`}</Typography>
                                </Box>
                                {user.id === currentUser?.id
                                    ? (
                                        <Typography variant="body2" fontWeight="bold" color="primary">
                                            You
                                        </Typography>
                                    )
                                    : (
                                        <IconButton onClick={() => removeAssigneeFormHandler(user.id)}>
                                            <DeleteOutline color="error" />
                                        </IconButton>
                                    )}
                            </Box>
                        ))
                    )}
            </Box>
            <Divider />
            {/* Unassigned Users with Checkboxes */}
            <Box minHeight="34vh" maxHeight="34vh" overflow="auto" display="flex" flexDirection="column" pt={1}>
                <Typography variant="h6">Choose who can view this form</Typography>
                <Typography variant="body1" color="textDisabled" gutterBottom>Select the customers</Typography>
                <Box flex={1} width="100%" display="flex" flexDirection="column" alignItems={notAssignedUsers.length === 0 ? 'center' : 'start'} gap={1} justifyContent={notAssignedUsers.length === 0 ? 'center' : 'start'}>{notAssignedUsers.length === 0
                    ? (
                        <Typography variant="body2" color="textSecondary" align="center" mt={2}>
                            No available users to add.
                        </Typography>
                    )
                    : (
                        notAssignedUsers.map((user) => {
                            if (user.id === currentUser?.id) return null;
                            return <Box key={user.id} display="flex" justifyContent="space-between" alignItems="center" width="100%" py={1}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Avatar src={ImageClass.userPlacedholder} />
                                    <Typography variant="body2">
                                        {`${user.first_name} ${user.last_name}`}
                                    </Typography>
                                </Box>
                                <Checkbox
                                    checked={selectedUsers.includes(user.id)}
                                    onChange={() => assignUserFormHandler(user.id)}
                                />
                            </Box>;
                        })
                    )}</Box>
            </Box>
        </Box>
    );
};

export default AssigneeComponent;
